
    import './styles.scoped.css';
    export default {
  "toggle-button": "awsui_toggle-button_1a743_zfic0_6",
  "variant-normal": "awsui_variant-normal_1a743_zfic0_6",
  "pressed": "awsui_pressed_1a743_zfic0_15",
  "variant-icon": "awsui_variant-icon_1a743_zfic0_21"
};
  